import React from 'react'
import PropTypes from 'prop-types'

import ScanPanelContainer from '../../scans/panel_container'

const ScanPanel = (props) => {
  const scanDateProps = {
    scan: props.currentScan,
    records: props.records,
    type: props.type,
    updateScan: props.updateScan,
  }

  return (
    <ScanPanelContainer
      {...props}
      type={props.type}
      header={props.header}
      scan={props.currentScan}
      scanDateProps={scanDateProps}
      videoId={props.videoId}
    />
  )
}

ScanPanel.propTypes = {
  type: PropTypes.string,
  header: PropTypes.string,
  records: PropTypes.object,
  user: PropTypes.object,
  currentScan: PropTypes.object,
  updateScan: PropTypes.func.isRequired,
  status: PropTypes.object,
  history: PropTypes.object,
  isMessageShown: PropTypes.bool,
  showMessage: PropTypes.func,
  hideMessage: PropTypes.func,
  videoId: PropTypes.string,
}

export default ScanPanel
